export default __webpack_public_path__ + "static/media/Akhlak-Hossasin-Jim-Projects-Digital-Clock-480.dfa6213d.webp";